import { useCurrentUser } from '@/hooks/use-current-user';
/**
 * Clinic-scoped permission check for UI affordances. The server enforces every
 * action per study; this only keeps buttons that would 403 off the screen (a
 * View Only user used to see Edit, fill the form in, and be refused). Super
 * admins pass on every clinic.
 */
export function useHasClinicPermission(clinicId, permission) {
    const { currentUser, isSuperAdmin } = useCurrentUser();
    if (isSuperAdmin)
        return true;
    if (!clinicId || !currentUser)
        return false;
    return currentUser.clinicRoles.some((cr) => cr.clinicId === clinicId && cr.permissions.includes(permission));
}
